import React from "react"
import { ChatConversation } from "./ChatConversation"

export const Messages = () => {
  return (
    <div className="flex-column flex-grow-1">
      <ChatConversation />
    </div>
  )
}